import { AnalyticsEvent, AnalyticsEventTemplate, EventName } from './analytics-event';

export class ErrorEvent implements AnalyticsEvent {
  event: EventName = 'error';

  error_action?: string;

  field_name?: string;

  error_type?: string;

  constructor(template: AnalyticsEventTemplate<ErrorEvent> = {}) {
    Object.assign(this, template);
  }
}
